import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

// Google Maps must be on `window` before AppModule is imported — map-view.component.ts
// references `google.maps.Map` at decorator-evaluation time.
function loadGoogleMaps(apiKey: string): Promise<void> {
  if (!apiKey) {
    return Promise.reject(new Error('GOOGLE_MAPS_API_KEY is not set for this build target'))
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}`
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Failed to load Google Maps JS API'))
    document.head.appendChild(script)
  })
}

loadGoogleMaps(environment.GOOGLE_MAPS_API_KEY)
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err))
